import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { LocalStorageKey } from "@/common/constants/localStorage";
import { LocalStorageHelper } from "@/common/helpers/storage/localStorage";

import { THEMES } from "../../common/constants/common";
import { AppThunkAction } from "./../index";

export interface AppSettings {
  theme: THEMES;
}

export interface AppCommonState {
  isAppInitialized: boolean;
  settings: AppSettings;
  isNavOpened: boolean;
  isAssistantOpened: boolean;
  warnings: Array<string>;
}

const themeInLocalStorage = LocalStorageHelper.getItem(LocalStorageKey.theme);

const initialState: AppCommonState = {
  isAppInitialized: false,
  settings: {
    theme: themeInLocalStorage ? JSON.parse(themeInLocalStorage || "") : THEMES.LIGHT,
  },
  isNavOpened: true,
  isAssistantOpened: false,
  warnings: [],
};

export const appCommonSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    appInitialized: (state) => {
      state.isAppInitialized = true;
    },
    prerenderConfigurationsStarted: () => {},
    _navEnabled: (state) => {
      state.isNavOpened = true;
    },
    _navDisabled: (state) => {
      state.isNavOpened = false;
    },
    _assistantBlockEnabled: (state) => {
      state.isAssistantOpened = true;
    },
    _assistantBlockDisabled: (state) => {
      state.isAssistantOpened = false;
    },
    _themeChange: (state, action: PayloadAction<THEMES>) => {
      state.settings.theme = action.payload;
      LocalStorageHelper.setItem(LocalStorageKey.theme, JSON.stringify(action.payload));
    },
    _addWarning: (state, action: PayloadAction<string>) => {
      state.warnings.push(action.payload);
    },
  },
});

export const {
  prerenderConfigurationsStarted,
  appInitialized,
  _navEnabled,
  _navDisabled,
  _assistantBlockEnabled,
  _assistantBlockDisabled,
  _themeChange,
  _addWarning,
} = appCommonSlice.actions;

export const appCommonReducer = appCommonSlice.reducer;

export const toggleNav = (): AppThunkAction => (dispatch, getState) => {
  const {
    app: { isNavOpened },
  } = getState();
  if (isNavOpened) {
    dispatch(_navDisabled());
  } else {
    dispatch(_navEnabled());
  }
};
export const hideNav = (): AppThunkAction => (dispatch) => {
  dispatch(_navDisabled());
};
export const showNav = (): AppThunkAction => (dispatch) => {
  dispatch(_navEnabled());
};

export const toggleAssistantBlock = (): AppThunkAction => (dispatch, getState) => {
  const {
    app: { isAssistantOpened: isAssistantBlockOpened },
  } = getState();
  if (isAssistantBlockOpened) {
    dispatch(_assistantBlockDisabled());
  } else {
    dispatch(_assistantBlockEnabled());
  }
};
export const hideAssistantBlock = (): AppThunkAction => (dispatch) => {
  dispatch(_assistantBlockDisabled());
};
export const showAssistantBlock = (): AppThunkAction => (dispatch) => {
  dispatch(_assistantBlockEnabled());
};
